/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery, useClient, useMutation } from "jsonapi-react";
import _ from "lodash";
import DataTable from "react-data-table-component";
import { AppContext } from "../../context/AppContext";
import ContractorFormComponent from "../../components/ContractorFormComponent/ContractorFormComponent";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import { useToasts } from "react-toast-notifications";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import ModalRightComponent from "../../components/common/ModalRightComponent/ModalRightComponent";
import SearchBar from "../../components/common/Search/Search";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import {
  checkModuleAddPermission,
  checkModuleDeletePermission,
  checkModuleEditPermission,
  formatTextWithFallback,
  trimDoubleSpace,
  validatorModule,
  getCurrentWindowParams,
  checkModuleGeneralPermission,
  filterIdsMultiselect,
} from "../../helpers/helpers";
import Select from "react-select";
import { apiRoutes, EXPORT_TYPES } from "../../constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ContextMenuContentWrapper from "../../components/common/ContextMenuContentWrapper";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { convertToFilterQuery, defaultSelectOption } from "../../helpers/utils";
import DynamicExport from "../../components/DynamicExport";
import BulkActionModal from "../../components/BulkActionModal/BulkActionModal";
import PillText from "../../components/PillText/PillText";

const Contractor = ({ location }) => {
  const history = useHistory();
  const initialState = {
    name: "",
  };

  const validationFormat = [
    {
      field: "name",
      isRequired: true,
      fieldName: "Contract Name",
    },
    // {
    //   field: "prefix",
    //   isRequired: true,
    //   fieldName: "Prefix",
    // },
  ];
  const initialErrorState = {
    name: "",
    // prefix: "",
  };
  const { addToast } = useToasts();

  let optionsRef = React.useRef();

  const {
    showRightModal,
    manageRightModal,
    showModal,
    manageModal,
    initialPageParams,
    updateInitialPageParams,
    setPageUrlParams,
    userRoleDetails,
    manageLoader,
    setProfilePageUrlParams,
  } = React.useContext(AppContext);
  //useBodyClass('modal-open');\
  const [mode, setMode] = React.useState("");
  const [contractorName, setContractorName] = React.useState("");
  // const [contractorPrefix, setContractorPrefix] = React.useState("");
  const [currentContractorId, setCurrentContractorId] = React.useState(0);
  const [currentContractAddedProfiles, setCurrentContractAddedProfiles] =
    React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [intialDataLoaded, setInitialDataLoaded] = React.useState(false);

  const [searchQueryString, setSearchQueryString] = React.useState("");
  const [formState, updateFormState] = React.useState(initialState);
  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);

  const windowParams = getCurrentWindowParams();
  const pageNumber = windowParams.get("page");
  const [currentPageNumber, setCurrentPageNumber] = React.useState(
    Number(pageNumber) || 1
  );

  const [testData, setTestData] = React.useState();

  const [profilesAdded, setProfilesAdded] = React.useState();

  const [resetPaginationDataTable, setResetPaginationDataTable] =
    React.useState(false);

  const [searchGoingOn, setSearchGoingOn] = React.useState(false);
  const [activePage, setactivePage] = React.useState(null);
  const [errorState, setErrorState] = React.useState(initialErrorState);
  const [createContractor] = useMutation(apiRoutes.contract);
  const [filterApplied, setFilterApplied] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");
  const [disableExport, setdisableExport] = React.useState(true);
  const [deleteLoader, setDeleteLoader] = React.useState(false);
  const [showSelectRows, setShowSelectRows] = React.useState("");
  const [applicantProfile, setapplicantProfile] = useState([]);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const [showBulkOptions, setShowBulkOptions] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [bulkAction, setBulkAction] = useState(false);

  const handleMouseDownOptions = (event) => {
    if (
      !event?.target?.classList.contains("dropdown-menu") &&
      optionsRef?.current &&
      !optionsRef?.current?.contains(event?.target)
    )
      setShowBulkOptions(false);
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleMouseDownOptions);
    return () => {
      document.removeEventListener("mousedown", handleMouseDownOptions);
    };
  });

  const token = localStorage.getItem("access_token");

  const client = useClient();
  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  let paginationSettings;
  if (searchGoingOn) {
    paginationSettings = {
      number: 1,
      size: rowsPerPage,
    };
  } else {
    paginationSettings = {
      number: currentPageNumber,
      size: rowsPerPage,
    };
  }

  let initialSearchKey;
  const searchWord = window.location.hash.split("search=")[1];
  if (searchWord) {
    initialSearchKey = decodeURI(searchWord);
  } else {
    initialSearchKey = "";
  }

  const [filter, setFilter] = React.useState({
    search: initialSearchKey,
  });

  const selectProfileLinked = (e) => {
    setProfilesAdded(e);
  };

  const contractors = useQuery(
    activePage && [
      apiRoutes.contract,
      {
        // filter: {
        //   search: searchQueryString,
        // },
        filter: filter,
        page: paginationSettings,
      },
    ],
    { client }
  );

  React.useEffect(() => {
    if (!contractors.isFetching && !contractors.isLoading) {
      if (contractors?.data?.length === 0) {
        setdisableExport(true);
      } else {
        setdisableExport(false);
      }
      setInitialDataLoaded(true);
    } else {
      setInitialDataLoaded(false);
    }
  }, [contractors]);

  React.useEffect(() => {
    if (location) {
      updateInitialPageParams(location);
    }
  }, []);

  const toggleResetPagination = () => {
    setResetPaginationDataTable((prevToggle) => !prevToggle);
  };

  const url = useLocation();

  const setSearchQueryFromURL = () => {
    const searchWord = windowParams.get("search");
    if (String(searchWord ?? "").length > 0)
      setSearchQueryString(decodeURI(searchWord));
    else setSearchQueryString("");
  };

  const setCurrentPageFromURL = () => {
    const pageNumber = windowParams.get("page");
    if (pageNumber && pageNumber > 0) {
      setCurrentPageNumber(Number(pageNumber));
      setactivePage(Number(pageNumber));
      toggleResetPagination();
    } else {
      setCurrentPageNumber(1);
      setactivePage(1);
      toggleResetPagination();
    }
  };

  useEffect(() => {
    setCurrentPageFromURL();
    setSearchQueryFromURL();
  }, [url]);

  // React.useEffect(() => {
  //   if (initialPageParams) {
  //     setCurrentPageNumber(Number(pageNumber));
  //     // setactivePage(initialPageParams.initialPageNumber);
  //     setactivePage(Number(pageNumber));
  //     setSearchQueryString(initialPageParams.initialSearchKey);
  //   }
  // }, [initialPageParams, pageNumber]);

  const getTestDataOptions = () => [
    defaultSelectOption(),
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const FilterSection = () => {
    return (
      <div className="advance-filter">
        <div className="mb-2">
          <span>Contracts</span>
          <div>
            <Select
              placeholder="Select"
              className="cutomSelect"
              classNamePrefix="react-select"
              value={profilesAdded}
              onChange={(e) => selectProfileLinked(e)}
              options={[
                { label: "Select", value: null },
                { label: "No profiles added", value: 0 },
                { label: "Profiles added", value: 1 },
              ]}
              defaultValue={defaultSelectOption()}
            />
          </div>
        </div>
        {checkModuleGeneralPermission(
          userRoleDetails,
          "organisation",
          "view_test_data",
          {},
          true
        ) && (
          <div>
            <span>Test Data</span>
            <Select
              placeholder="Select"
              className="cutomSelect"
              classNamePrefix="react-select"
              options={getTestDataOptions()}
              isMulti={false}
              value={testData}
              defaultValue={defaultSelectOption()}
              onChange={(selectedOptions) => setTestData(selectedOptions)}
            />
          </div>
        )}
      </div>
    );
  };

  const [updateContractor] = useMutation(
    apiRoutes.contractUpdate.replace("{id}", currentContractorId),
    { method: "PUT", client }
  );
  const onInputChange = (e) => {
    if (e.target.name === "name") {
      setContractorName(trimDoubleSpace(e.target.value?.toUpperCase()));
    }
    updateFormState({
      ...formState,
      [e.target.name]: trimDoubleSpace(e.target.value?.toUpperCase()),
    });
  };
  const manageModalSettings = (status) => {
    manageRightModal(status);
  };

  const deleteContractorDetails = async () => {
    setDeleteLoader(true);
    const { error } = await client.delete(
      apiRoutes.contractUpdate.replace("{id}", currentContractorId)
    );
    if (error === undefined) {
      setDeleteLoader(false);
      if (contractors?.data?.length === 1 && currentPageNumber > 1) {
        paginationSettings = {
          number: currentPageNumber - 1,
          size: rowsPerPage,
        };
        setCurrentPageNumber(currentPageNumber - 1);
      } else {
        contractors.refetch();
      }
      addToast(DISPLAY_TEXTS.CONTRACT_DELETED, { appearance: "success" });
    } else {
      addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
    }
    setCurrentContractorId(0);
    setCurrentContractAddedProfiles(0);
    manageModal(false);
    setDeleteLoader(false);
  };

  const submitNewContractor = async () => {
    let errors = errorValidate();

    setErrorState(errors);
    if (Object.keys(errors).length === 0) {
      if (formState.name !== "") {
        const { data, error } = await createContractor({
          ...formState,
        });
        if (data && error === undefined) {
          contractors.refetch();
          addToast(DISPLAY_TEXTS.CONTRACT_ADDED, { appearance: "success" });
        } else if (error !== undefined && error.detail) {
          addToast(error.detail, { appearance: "error" });
        } else {
          addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
        }
        manageModalSettings(false);
        setContractorName("");
      }
    }
  };

  const updateContractorData = async () => {
    let errors = errorValidate();

    setErrorState(errors);
    if (Object.keys(errors).length === 0) {
      const { data, error } = await updateContractor({
        ...formState,
        id: currentContractorId,
      });
      if (data && error === undefined) {
        contractors.refetch();
        addToast(DISPLAY_TEXTS.CONTRACT_UPDATED, { appearance: "success" });
      } else if (error !== undefined && error.detail) {
        addToast(error.detail, { appearance: "error" });
      } else {
        addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
      }
      setMode("");
      manageModalSettings(false);
      setContractorName("");
    }
  };

  const addNewContractor = () => {
    setMode("add");
    setContractorName("");

    updateFormState({
      name: "",
    });
    setErrorState({
      name: "",
    });
    manageRightModal(true);
  };

  const updateContractorDetails = (id) => {
    setMode("edit");
    setCurrentContractorId(id);
    const exisitingData = _.keyBy(contractors.data, "id")[id];
    setContractorName(exisitingData.name);

    updateFormState({
      name: exisitingData.name,
    });
    setErrorState({
      name: "",
    });
    manageModalSettings(true);
  };

  const manageDeletedOption = (contractToDelete) => {
    setCurrentContractorId(contractToDelete?.id);
    setCurrentContractAddedProfiles(contractToDelete?.profilesAdded);
    manageModal(true);
  };

  const doCloseModal = () => {
    setCurrentContractorId(0);
    setCurrentContractAddedProfiles(0);
    manageModal(false);
  };
  const errorValidate = () => {
    let errors = validatorModule(formState, validationFormat);

    return errors;
  };
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };

  const getContractParam = (name) => {
    if (String(name ?? "").length) {
      const param = new URLSearchParams();
      param.append("contract", name ?? "");
      return param.toString();
    }
    return "";
  };

  const getEvent = (mode) => {
    if (mode.mode === "edit") {
      updateContractorDetails(mode.contractors.id);
    }

    if (mode.mode === "delete") {
      manageDeletedOption(mode.contractors);
    }
    if (mode.mode === "profileLink") {
      history.push(`/all-profile?${getContractParam(mode.contractors.id)}`);
    }
  };

  let menuRef = React.useRef();
  const [tableUserId, setTableUserId] = React.useState("");

  React.useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      if (
        event.target.className !== "user-role-action-icons" &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setTableUserId("");
      }
    });
  });

  const showHideContextMenu = (userid) => {
    setTableUserId(userid);
  };

  const showContextActionMenu = (contract) => {
    const hasContractEditPermission = checkModuleEditPermission(
      userRoleDetails,
      "contract",
      "contract",
      contract
    );

    const hasContractDeletePermission = checkModuleDeletePermission(
      userRoleDetails,
      "contract",
      "contract",
      contract
    );

    return (
      (hasContractEditPermission || hasContractDeletePermission) && (
        <div className="contextMenu">
          {tableUserId === contract.id && (
            <ContextMenuContentWrapper
              showContextMenu={tableUserId === contract.id}
              handleContextMenuClose={() => setTableUserId("")}
            >
              <ul ref={menuRef}>
                {hasContractEditPermission && (
                  <>
                    <li onClick={() => updateContractorDetails(contract.id)}>
                      <button>
                        <i className="iconsminds-pen user-role-action-icons"></i>
                        Edit
                      </button>
                    </li>
                  </>
                )}
                {hasContractDeletePermission && (
                  <li onClick={() => manageDeletedOption(contract)}>
                    <button>
                      <i className="simple-icon-trash user-role-action-icons delete"></i>
                      Delete
                    </button>
                  </li>
                )}
              </ul>
            </ContextMenuContentWrapper>
          )}
          <span
            className="user-role-action-icons"
            onClick={() => showHideContextMenu(contract.id)}
          >
            <i></i>
          </span>
        </div>
      )
    );
  };

  const columns = [
    {
      name: "Contract",
      selector: (row) => row["name"],
      sortable: true,
      cell: (contractors) => (
        <ProfileCard
          data={contractors}
          mode="contract"
          actions={userRoleDetails}
          actionsToParent={(mode) => getEvent({ mode, contractors })}
        />
      ),
    },
    {
      name: "Added profiles",
      maxWidth: 200,
      selector: (row) => row["profilesAdded"],
      sortable: true,
      center: true,
      cell: (contract) => <>{formatTextWithFallback(contract.profilesAdded)}</>,
      hide: "md",
    },
    {
      name: "Test Data",
      sortable: false,
      maxWidth: "300px",
      hide: "md",
      omit: !checkModuleGeneralPermission(
        userRoleDetails,
        "organisation",
        "view_test_data",
        {},
        true
      ),
      cell: (contract) => (
        <PillText
          label={contract?.isTestContract ? "Yes" : "No"}
          type={contract?.isTestContract ? "active" : "inactive"}
          mapper={{ active: "Yes", inactive: "No" }}
        />
      ),
    },
    {
      name: "Actions",
      maxWidth: 150,
      minWidth: 150,
      sortable: false,
      cell: (contract) => (
        <>
          {contract.profilesAdded > 0 && (
            <Link
              to={`/all-profile?${getContractParam(contract.id)}`}
              title="View linked profiles"
            >
              <span className="iconsminds-link user-role-action-icons edit"></span>
            </Link>
          )}
          {showContextActionMenu(contract)}
        </>
      ),
      hide: "md",
      right: true,
    },
  ];

  let paginationGoing = false;
  const onChangePage = (page) => {
    setSearchGoingOn(false);
    paginationGoing = true;
    setCurrentPageNumber(page);
    const setParams = {
      page: page,
      searchQueryString: searchQueryString,
      initialPageParams: initialPageParams,
    };
    setPageUrlParams(setParams);
  };

  const onChangeRowsPerPage = (rows) => {
    setRowsPerPage(rows);
  };

  let searchGoing = false;
  const onSearchInputChange = (searchQuery) => {
    searchGoing = true;
    setSearchGoingOn(true);
    setSearchQueryString(searchQuery);
    setFilter({ ...filter, search: searchQuery });
    setactivePage(1);
    const setParams = {
      page: 1,
      searchQueryString: searchQuery,
      initialPageParams: initialPageParams,
    };
    setPageUrlParams(setParams);
  };

  window.onpopstate = (e) => {
    if (!searchGoing && !paginationGoing) {
      const searchWord = window.location.hash.split("search=")[1];
      const wordString = decodeURI(searchWord);
      if (searchWord) {
        setSearchQueryString(wordString);
        setFilter({ ...filter, search: wordString });
      } else {
        setSearchQueryString("");
        setFilter({ ...filter, search: "" });
      }

      const pageNumber = window.location.hash.split("page=")[1];
      if (pageNumber) {
        const pageFromUrl = pageNumber.split("&")[0];
        setCurrentPageNumber(Number(pageFromUrl));
      } else {
        setCurrentPageNumber(1);
      }
    } else {
      searchGoing = false;
      paginationGoing = false;
    }
  };
  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };

  const handleResetFilter = () => {
    for (let key of ["profiles_added", "profiles_added_gt", "test_data"]) {
      delete filter[key];
    }
    setTestData();
    setFilter({ ...filter });
    setProfilesAdded();
  };

  React.useEffect(() => {
    if (
      _.hasIn(filter, "profiles_added") ||
      _.hasIn(filter, "profiles_added_gt") ||
      _.hasIn(filter, "test_data")
    ) {
      setFilterApplied(true);
      return;
    }
    setFilterApplied(false);
  }, [filter]);

  const handleApplyFilter = () => {
    setCurrentPageNumber(1);
    showFilter(false);

    let updatedFilter = { ...filter };

    if (profilesAdded?.value == 0) {
      delete updatedFilter.profiles_added_gt;
      updatedFilter.profiles_added = 0;
    } else if (profilesAdded?.value == 1) {
      delete updatedFilter.profiles_added;
      updatedFilter.profiles_added_gt = 0;
    } else {
      delete updatedFilter.profiles_added;
      delete updatedFilter.profiles_added_gt;
    }
    const selectedTestData =
      testData?.value !== undefined && testData?.value !== ""
        ? testData?.value
        : null;

    if (selectedTestData !== null) {
      updatedFilter.test_data = selectedTestData;
    } else {
      delete updatedFilter.test_data;
    }
    setFilter(updatedFilter);
  };

  const closeReportSuccessPopup = () => {
    setShowSuccessModal(false);
    setShowSuccessMessage("");
  };

  useEffect(() => {
    if (!filterApplied) return;
    filter.profiles_added_gt === 0
      ? setShowSelectRows(false)
      : setShowSelectRows(true);
  }, [filterApplied, filter]);

  const onSelectRows = (rows) => {
    setapplicantProfile(filterIdsMultiselect(rows?.selectedRows));
  };

  const showOptions = () => {
    setShowBulkOptions(true);
  };

  const checkIsSelectabale = () => {
    if (
      filterApplied &&
      filter.profiles_added === 0 &&
      checkBulkActionPermission()
    ) {
      return true;
    }
  };

  const showBulkActionModal = (type) => {
    setShowBulkOptions(false);
    setShowActionModal(true);
    setBulkAction(type);
  };

  const onBulkActionSuccess = () => {
    setToggleClearRows(!toggledClearRows);
    setapplicantProfile([]);
    setShowActionModal(false);
    const deletedCount = applicantProfile?.length || 0;
    const newTotalItems =
      (contractors?.meta?.pagination?.count || 0) - deletedCount;
    const totalPages = Math.ceil(newTotalItems / rowsPerPage);

    if (currentPageNumber > totalPages && totalPages > 0) {
      const newPage = totalPages;
      paginationSettings = {
        number: newPage,
        size: rowsPerPage,
      };
      setCurrentPageNumber(newPage);
    } else {
      contractors.refetch();
    }
  };

  const checkBulkActionPermission = () => {
    return checkModuleGeneralPermission(
      userRoleDetails,
      "contract",
      "perform_multiselect_actions",
      {},
      true
    );
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-header">
            <h1>Contracts</h1>
            <div className="applicantFilter">
              <div className="desktopSearch">
                <SearchBar
                  id="search-desktop"
                  onSearchInputChange={onSearchInputChange}
                  popstateText={searchQueryString}
                />
              </div>
              <div
                className={
                  showMobileDataFilter ? "table-filter active" : "table-filter"
                }
              >
                <div
                  className="filter-hide"
                  onClick={() => showFilter(false)}
                ></div>
                <div className="filter-form">
                  <div className="mobile-search">
                    <SearchBar
                      id="search-mobile"
                      onSearchInputChange={onSearchInputChange}
                      popstateText={searchQueryString}
                    />
                  </div>
                  <h4 className="advanced-filter-heading">Advanced Search</h4>
                  <FilterSection />
                  <div className="d-flex w-100 align-items-center justify-content-end mt-3">
                    <button
                      className="btn btn-primary mr-2"
                      onClick={() => {
                        handleResetFilter();
                      }}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-secondary m-0"
                      onClick={() => {
                        handleApplyFilter();
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
              <div
                className={`tableFilterButton rightAlign ${
                  filterApplied ? "btn-secondary" : ""
                }`}
                title="Advance Search"
                onClick={() => showFilter(true)}
              >
                <i className="iconsminds-filter-2"></i>
              </div>
              {checkBulkActionPermission() &&
                showSelectRows &&
                checkIsSelectabale() && (
                  <div className="d-none d-md-block dropdown ">
                    <button
                      type="button"
                      className="tableFilterButton ml-2 rightAlign btn btn-secondary"
                      disabled={applicantProfile.length === 0}
                      onClick={() => showOptions()}
                    >
                      <i className="simple-icon-settings"></i>
                    </button>
                    {showBulkOptions && (
                      <div
                        ref={optionsRef}
                        id="create-dropdown"
                        className={`dropdown-content dropdown-menu dropdown-menu-right mt-1 ${
                          showBulkOptions ? "show" : ""
                        }`}
                      >
                        {checkModuleDeletePermission(
                          userRoleDetails,
                          "contract",
                          "contract",
                          {},
                          true
                        ) && (
                          <button
                            className="dropdown-item"
                            onClick={() => showBulkActionModal("Delete")}
                          >
                            <i className={`${"simple-icon-trash mr-2"}`}></i>
                            Delete
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              {checkModuleAddPermission(
                userRoleDetails,
                "contract",
                "contract"
              ) && (
                <button
                  type="button"
                  title="Add Contract"
                  className="tableFilterButton ml-2 rightAlign btn-secondary"
                  onClick={() => addNewContractor()}
                >
                  <>+</>
                </button>
              )}
              <DynamicExport
                permission={checkModuleGeneralPermission(
                  userRoleDetails,
                  "contract",
                  "export_contract_list"
                )}
                type={EXPORT_TYPES.CONTRACT}
                apiType="organisation"
                exportUrl={apiRoutes.contractListExport}
                exportFilter={convertToFilterQuery(filter)}
                disabled={disableExport}
                className="ml-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 mb-4">
          <div className="card">
            <div
              className={
                contractors.isLoading ||
                contractors.isFetching ||
                !intialDataLoaded
                  ? "card-body dataTableOuter table-loader"
                  : "card-body dataTableOuter"
              }
            >
              <DataTable
                className={checkIsSelectabale() ? "selectable" : ""}
                subHeader={true}
                selectableRows={checkIsSelectabale()}
                selectableRowDisabled={!filterApplied}
                onSelectedRowsChange={onSelectRows}
                clearSelectedRows={toggledClearRows}
                progressPending={
                  contractors.isLoading ||
                  contractors.isFetching ||
                  !intialDataLoaded
                }
                progressComponent={<p>&nbsp;</p>}
                columns={columns}
                data={contractors.data}
                customStyles={customStyles}
                paginationServer={true}
                striped={true}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                pagination={true}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={
                  contractors.meta && contractors.meta.pagination.count
                }
                paginationDefaultPage={activePage}
                paginationResetDefaultPage={resetPaginationDataTable}
              />
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        show={showModal}
        header={<b>Confirm Delete</b>}
        content={
          <>
            <p>
              Are you sure you want to delete the selected Contract details ?
            </p>
            {currentContractAddedProfiles > 0 && (
              <p>
                Please note: {currentContractAddedProfiles} profiles are linked
                to this contract{" "}
              </p>
            )}
          </>
        }
        onSubmitCallback={deleteContractorDetails}
        isLoaderActive={deleteLoader}
        onCloseCallback={doCloseModal}
        submitButtonText="Delete"
        customClass="delete"
      />

      <ModalRightComponent
        show={showRightModal}
        header={mode === "add" ? "Add Contract" : "Update Contract"}
        submitButtonText={mode === "add" ? "Submit" : "Update"}
        classes="normal-right-modal"
        content={
          <ContractorFormComponent
            title={
              mode === "add"
                ? 'Submitting below form will add "a new contract".'
                : 'Submitting below form will update "the contract".'
            }
            contractorName={contractorName}
            errorState={errorState}
            updateInputChange={onInputChange}
          />
        }
        onSubmitCallback={() =>
          mode === "add" ? submitNewContractor() : updateContractorData()
        }
        onCloseCallback={() => manageModalSettings(false)}
      />

      <div className={`reportStatusPopup ${showSuccessModal ? "show" : ""}`}>
        <div className="popUp">
          <div className="content">{showSuccessMessage}</div>
          <div className="action">
            <button
              className="btn btn-secondary"
              onClick={closeReportSuccessPopup}
            >
              OK
            </button>
          </div>
        </div>
      </div>
      {showActionModal && bulkAction && (
        <>
          <BulkActionModal
            userID={applicantProfile}
            action={bulkAction}
            type={"Contract"}
            closeBulkModal={() => setShowActionModal(false)}
            actionSuccess={() => onBulkActionSuccess()}
          />
        </>
      )}
    </>
  );
};

export default Contractor;
